/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_ProsInputs */

const en_pc_rv_pros = /** @type {(inputs: Pc_Rv_ProsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What works`)
};

const zh_pc_rv_pros = /** @type {(inputs: Pc_Rv_ProsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`做得好的`)
};

/**
* | output |
* | --- |
* | "What works" |
*
* @param {Pc_Rv_ProsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_pros = /** @type {((inputs?: Pc_Rv_ProsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_ProsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_pros(inputs)
	return zh_pc_rv_pros(inputs)
});
export { pc_rv_pros as "pc.rv.pros" }